import { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import { supabase } from "@/lib/supabaseClient";
import { prefetchOfflineData } from "@/lib/prefetch";

const PREFETCH_INTERVAL_MS = 10 * 60 * 1000;
const lastRun = {};

// Warms every role-relevant offline snapshot shortly after login and again on
// reconnect, so tabs never visited this session still work in airplane mode.
export const OfflinePrefetch = () => {
  const { user, role, activeCompanyId, isSuperAdmin, dataLoading } = useAuth();

  useEffect(() => {
    if (!user || dataLoading || !navigator.onLine) return;
    const key = `${user.id}:${activeCompanyId || "global"}`;
    const run = () => {
      if (!navigator.onLine) return;
      if (Date.now() - (lastRun[key] || 0) < PREFETCH_INTERVAL_MS) return;
      lastRun[key] = Date.now();
      prefetchOfflineData(supabase, { uid: user.id, role, activeCompanyId, isSuperAdmin }).catch(() => {});
    };
    const t = setTimeout(run, 0); // fire immediately: network can vanish seconds after login
    window.addEventListener("online", run);
    return () => { clearTimeout(t); window.removeEventListener("online", run); };
  }, [user, role, activeCompanyId, isSuperAdmin, dataLoading]);

  return null;
};
